import { Logger } from "src/latest/src/services";

export default class CustomStorage {
    private static storageType: Storage | null = null;
  
    static init(): void {
      try {
        localStorage.setItem("i2i-test", "1");
        localStorage.removeItem("i2i-test");
  
        this.storageType = localStorage;
      } catch (err) {
        Logger.error(err);
        this.storageType = null; // Fallback to null if localStorage is not available
      }
    }
  
    static setItem(key: string, value: string): void {
      if (this.storageType) {
        this.storageType.setItem(key, value);
      } else {
        Logger.warn("Storage is not initialized.");
      }
    }
  
    static getItem(key: string): string | null {
      if (this.storageType) {
        return this.storageType.getItem(key);
      }

      Logger.warn("Storage is not initialized.");
      
      return null;
    }
  
    static removeItem(key: string): void {
      if (this.storageType) {
        this.storageType.removeItem(key);
      } else {
        Logger.warn("Storage is not initialized.");
      }
    }
  
    static clear(): void {
      if (this.storageType) {
        this.storageType.clear();
      } else {
        Logger.warn("Storage is not initialized.");
      }
    }
  }
  
  CustomStorage.init();